import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from 'antd';
import { localeTxt, sortedLocales } from 'libs/i18n';
import { BeeyLocale } from 'libs/locales/locale';
import { normalizeString } from 'libs/normalize-string';
export const languageFilter = (selectInput, option) => {
    var _a, _b;
    const label = (_b = (_a = option === null || option === void 0 ? void 0 : option.children) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.children;
    if (typeof label !== 'string') {
        return false;
    }
    const normalizedOption = normalizeString(label.toLocaleLowerCase());
    const normalizedSelectInput = normalizeString(selectInput.toLocaleLowerCase());
    return normalizedOption.startsWith(normalizedSelectInput);
};
const LanguageSelect = (props) => {
    const { id, className, locales, value, onChange, multiple, autoFocus, disabled, } = props;
    const options = sortedLocales(locales);
    const selectValue = multiple === true
        ? (Array.isArray(value) ? value.map((v) => v.code) : [])
        : value === null || value === void 0 ? void 0 : value.code;
    const handleChange = (val) => {
        // NOTE: We can safely create TLocale from a code here as all locale codes
        // in this component come from valid TLocale instances
        if (multiple === true) {
            onChange === null || onChange === void 0 ? void 0 : onChange(val.map((code) => BeeyLocale.fromCode(code)));
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange(BeeyLocale.fromCode(val));
        }
    };
    return (_jsx(Select, { id: id, className: className, mode: multiple === true ? 'multiple' : undefined, showSearch: true, autoFocus: autoFocus, value: selectValue, onChange: handleChange, optionFilterProp: "children", filterOption: languageFilter, disabled: disabled, children: options.map((option) => (_jsx(Select.Option, { value: option.code, children: _jsx("span", { children: localeTxt(option) }) }, option.code))) }));
};
export default LanguageSelect;
